import base64 from 'base-64';

/**
* Sets the required headers for doing a request in Staging.
* @returns {object} headers config.
*/
export function setHeaders() {
	const headers = new Headers();
	const credentials = 'medcontrol:nolte101';
	headers.append( 'Authorization', `Basic ${base64.encode( credentials )}` );
	headers.append( 'pragma', 'no-cache' );
	headers.append( 'cache-control', 'no-cache' );

	return headers;
}